<template>
	<div class="w-full" :style="style" v-scroll="handleScroll">
		<slot/>
	</div>
</template>

<script setup lang="ts">
import type {Ref} from "vue";
import {ref, onMounted} from "vue";
import {useNuxtApp} from "#imports";

const {$device} = useNuxtApp();

const props = defineProps<{
	// Whether to only activate the parallax for mobile screens
	onlyMobile?: boolean
}>();

const style: Ref<{ [key: string]: string } | null> = ref(null);

function handleScroll() {
	if (!props.onlyMobile || $device.isMobile) {
		const scrollPosition = typeof window !== 'undefined' ? window.scrollY : 0;
		const topPosition = (scrollPosition / 1.8)
		style.value = {
			willChange: 'transform',
			transform: `translate3d(0px, ${topPosition}px, 0px)`
		};
	} else {
		style.value = null;
	}
}

onMounted(() => {
	handleScroll();
});

</script>